/**
 * @param {string} collectionHeading
 * @param {elements} children
 */
function ContentCollection(props){
    let heading = null;

    if(props.collectionHeading !== undefined) {
        heading = <p className={"book-meeting__sublabel " + props.stylingClassname}>{props.collectionHeading}</p>;
    }

    return(
        <div className="book-meeting__textwrapper mt-3">
            {heading}
            <div>
                {props.children}
            </div>            
        </div>
    )
}
export default ContentCollection;